<template>
  <span>
    <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>

    <v-card class="card--flex-toolbar">
      <v-toolbar color="blue-grey lighten-5" class="elevation-0" tabs>
        <v-toolbar-title>Cadastro de Fornecedores</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-tabs-items v-model="active" style="min-height:300px">
          <v-tab-item key="1">
            <v-form v-model="valid">
              <v-container fluid>
                <v-layout row wrap>
                  <!-- LINHA 1, CAMPO CODIGO -->
                  <v-flex xs12 sm2>
                    <v-text-field
                      v-model="fornecedor.id"
                      label="Código"
                      v-bind:disabled="true"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-text-field
                      type="tel"
                      v-model="fornecedor.cnpj"
                      label="CNPJ"
                      v-mask="'##.###.###/####-##'"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm10>
                    <v-text-field v-model="fornecedor.nome" label="Nome" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm10>
                    <v-text-field v-model="fornecedor.endereco" label="Endereço" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-text-field v-model="fornecedor.numero" label="Número" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-text-field v-model="fornecedor.bairro" label="Bairro" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                     <e-select-cidade2 v-model="fornecedor.fk_cidade" :localidade="fornecedor.localidade" :uf="fornecedor.uf" @userSelect="onSelectCidade"/>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-text-field
                      v-model="fornecedor.cep"
                      label="CEP"
                      type="tel"
                      v-mask="'#####-###'"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm1>
                    <v-text-field v-model="fornecedor.uf" label="UF" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-text-field
                      type="tel"
                      v-model="fornecedor.celular"
                      label="Celular"
                      v-mask="'##-#####-####'"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-text-field
                      type="tel"
                      v-model="fornecedor.fixo"
                      label="Fixo"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field v-model="fornecedor.usuario" label="Usuário/Email" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      @click:append="showP = !showP"
                      v-model="fornecedor.senha"
                      :rules="senhaRules"
                      label="Senha"
                      required
                      :type="showP ? 'text' : 'password'"
                      :append-icon="showP ? 'visibility_off' : 'visibility'"
                    ></v-text-field>
                  </v-flex>

                </v-layout>
              </v-container>
            </v-form>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="salvar()" :loading="loading">Salvar</v-btn>
      </v-card-actions>
    </v-card>

    <div style="margin:50px"></div>
  </span>
</template>
<script>
// import store from '@/store'
import { showFlash, showError } from '@/utils'
import fornecedorService from '@/services/fornecedor'
import ESelectCidade2 from '@/components/ESelectCidade2'

export default {
  name: 'fornecedor',
  components: {
    ESelectCidade2
  },
  data () {
    return {
      senhaRules: [v => !!v || 'Campo obrigatório'],
      showP: false,
      fornecedor: {},
      itemList: [],
      searchInput: '',
      loading: false,
      valid: true,
      active: 0,
      modo: '',
      resultado: {},
      itemSenha: [
        'N',
        'S'
      ]
    }
  },
  mounted: async function () {
    try {
      // this.loading = true
      this.modo = 'A'
      this.fornecedor = await fornecedorService.getByFornecedor()
    } catch (error) {
      showError(error)
    } finally {
      this.loading = false
    }
  },
  computed: {
    isAlterar: function () {
      return this.modo === 'A'
    }
  },
  methods: {
    async salvar () {
      try {
        this.resultado = await fornecedorService.savePutfor(this.fornecedor)
        showFlash('Salvo com sucesso')
      } catch (error) {
        showError(error)
      } finally {
        this.loading = false
      }
    },
    onSelectCidade (item) {
      this.fornecedor.uf = item.uf
      this.fornecedor.fk_cidade = item.codigo
    }
  }
}
</script>
<style scoped>
.flex{
    height: 60px;
  }
</style>
